const strArray = [
  'Um',
  'Dois',
  'Três',
  'Quatro',
  'Cinco',
  'Seis',
  'Sete',
  'Oito',
  'Nove',
  'Dez',
  'Onze',
  'Doze',
  'Treze',
  'Quatorze',
  'Quinze',
  'Dezesseis',
  'Dezessete',
  'Dezoito',
  'Dezenove',
];
const strArrayDezenas = [
  'Vinte',
  'Trinta',
  'Quarenta',
  'Cinquenta',
  'Sessenta',
  'Setenta',
  'Oitenta',
  'Noventa',
];

const strArrayCentenas = [
  'Cento',
  'Duzentos',
  'Trezentos',
  'Quatrocentos',
  'Quinhentos',
  'Seiscentos',
  'Setecentos',
  'Oitocentos',
  'Novecentos',
];

/*
''' <summary>
''' Função auxiliar - Parte decimal a converter
''' </summary>
''' <param name="number">Parte decimal a converter</param>
*/
function getDecimal(numero: number): string {
  try {
    switch (true) {
      case numero === 0:
        return '';
      case numero >= 1 && numero <= 19:
        return `${strArray[numero - 1]}`;
      case numero >= 20 && numero <= 99:
        if (numero % 10 === 0)
          return `${strArrayDezenas[Math.trunc(numero / 10) - 2]}`;

        return `${strArrayDezenas[Math.trunc(numero / 10) - 2]} e ${getDecimal(
          numero % 10,
        )}`;
      default:
        return '';
    }
  } catch (error) {
    return '';
  }
}

/*
''' <summary>
''' Função auxiliar - Parte inteira a converter
''' </summary>
''' <param name="number">Parte inteira a converter</param>
*/
function getInteger(numero: number): string {
  try {
    const inteiro = Math.trunc(numero);
    switch (true) {
      case inteiro < 0:
        return `-${getInteger(-inteiro)}`;
      case inteiro === 0:
        return '';
      case inteiro >= 1 && inteiro <= 19:
        return `${strArray[inteiro - 1]} `;
      case inteiro >= 20 && inteiro <= 99:
        if (inteiro % 10 === 0)
          return strArrayDezenas[Math.trunc(inteiro / 10) - 2];
        return `${strArrayDezenas[Math.trunc(inteiro / 10) - 2]} e ${getInteger(
          inteiro % 10,
        )}`;
      case inteiro === 100:
        return 'Cem';
      case inteiro >= 101 && inteiro <= 999:
        if (inteiro % 100 === 0)
          return `${strArrayCentenas[Math.trunc(inteiro / 100) - 1]} `;

        return `${
          strArrayCentenas[Math.trunc(inteiro / 100) - 1]
        } e ${getInteger(inteiro % 100)}`;
      case inteiro >= 1000 && inteiro <= 1999:
        if (inteiro % 1000 === 0) return 'Mil';
        if (inteiro % 1000 <= 100) return `Mil e ${getInteger(inteiro % 1000)}`;
        return `Mil, ${getInteger(inteiro % 1000)}`;
      case inteiro >= 2000 && inteiro <= 999999:
        if (inteiro % 1000 === 0)
          return `${getInteger(Math.trunc(inteiro / 1000))}Mil`;
        if (inteiro % 1000 <= 100)
          return `${getInteger(Math.trunc(inteiro / 1000))}Mil e ${getInteger(
            inteiro % 1000,
          )}`;
        return `${getInteger(Math.trunc(inteiro / 1000))}Mil, ${getInteger(
          inteiro % 1000,
        )}`;
      case inteiro >= 2000000 && inteiro <= 999999999:
        if (inteiro % 1000000 === 0)
          return `${getInteger(Math.trunc(inteiro / 1000000))} Milhões`;
        if (inteiro % 1000000 <= 100)
          return `${getInteger(
            Math.trunc(inteiro / 1000000),
          )}Milhões e ${getInteger(inteiro % 1000000)}`;

        return `${getInteger(
          Math.trunc(inteiro / 1000000),
        )}Milhões, ${getInteger(inteiro % 1000000)}`;
      case inteiro >= 1000000000 && inteiro <= 1999999999:
        if (inteiro % 1000000000 === 0) {
          return 'Um Bilhão';
        }
        if (inteiro % 1000000000 <= 100) {
          return `${getInteger(
            Math.trunc(inteiro / 1000000000),
          )}Bilhão e ${getInteger(inteiro % 1000000000)}`;
        }

        return `${getInteger(
          Math.trunc(inteiro / 1000000000),
        )}Bilhão, ${getInteger(inteiro % 1000000000)}`;
      default:
        if (inteiro % 1000000000 === 0)
          return `${getInteger(Math.trunc(inteiro / 1000000000))} Bilhões`;
        if (inteiro % 1000000000 <= 100)
          return `${getInteger(
            Math.trunc(inteiro / 1000000000),
          )}Bilhões e ${getInteger(inteiro % 1000000000)}`;

        return `${getInteger(
          Math.trunc(inteiro / 1000000000),
        )}Bilhões, ${getInteger(inteiro % 1000000000)}`;
    }
  } catch (error) {
    return '';
  }
}

/*
''' <summary>
''' Função principal que recolhe o valor e chama as duas funções
''' auxiliares para a parte inteira e para a parte decimal
''' </summary>
''' <param name="number">Número a converter para extenso (Reais)</param>
'''
*/

const numeroToExtenso = (numero: number): string => {
  let cent = 0;

  try {
    // se for =0 retorna 0 reais
    if (numero === 0) return 'Zero Reais';
    // Verifica apenas a parte inteira
    const inteiro = Math.trunc(numero);
    // Verifica a parte decimal, ou seja, os centavos
    cent = Math.round((numero - inteiro) * 100);
    // Caso existam centavos
    if (cent > 0) {
      // Caso seja 1 não coloca "Reais" mas sim "Real"
      if (inteiro === 1) return `Um Real e ${getDecimal(cent)} centavo`;
      // Caso o valor seja inferior a 1 Real
      if (inteiro === 0) return `${getDecimal(cent)} centavos`;

      return `${getInteger(inteiro)} Reais e ${getDecimal(cent)} centavos`;
    }
    // Caso seja 1 não coloca "Reais" mas sim "Real"
    if (inteiro === 1) return 'Um Real';

    return `${getInteger(inteiro)} Reais`;
  } catch (error) {
    return '';
  }
};

export default numeroToExtenso;
